<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <!-- <observado-filters ref="filters" /> -->
    <b-card no-body class="mb-0">
      <div class="mx-2 mt-2">
          <b-row>
            <!-- Filter: Establishment Origin -->
            <b-col cols="12" sm="3">
              <b-form-group label="Establecimiento de Origen" label-for="filter-origin">
                <v-select
                  id="filter-origin"
                  v-model="filterOrigin"
                  :options="establishments"
                  label="name"
                  placeholder="Seleccionar establecimiento de origen"
                  @input="applyFilters"
                />
              </b-form-group>
            </b-col>

            <!-- Filter: Establishment Destiny -->
            <b-col cols="12" sm="3">
              <b-form-group label="Establecimiento de Destino" label-for="filter-destiny">
                <v-select
                  id="filter-destiny"
                  v-model="filterDestiny"
                  :options="establishments"
                  label="name"
                  placeholder="Seleccionar establecimiento de destino"
                  @input="applyFilters"
                />
              </b-form-group>
            </b-col>

            <!-- Filter: State -->
            <b-col cols="12" sm="2">
              <b-form-group label="Estado" label-for="filter-state">
                <b-form-select
                  id="filter-state"
                  v-model="filterState"
                  :options="stateOptions"
                  @change="applyFilters"
                  placeholder="Seleccionar estado"
                />
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="2" class="mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="secondary"
                @click="clearFilters"
              >
              <feather-icon icon="TrashIcon" class="mr-50" />
                <span class="align-middle">Limpiar</span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <!-- Column: State -->
          <template #cell(state)="data">
            <span :class="data.item.state === 'Alerta' ? 'state-alerta' : ''">
              {{ data.item.state }}
            </span>
          </template>

          <!-- Column: Created At -->
          <template #cell(created_at)="data">
            <span>{{ moment(data.item.created_at).format('YYYY-MM-DD - HH:mm') }}</span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button
              size="sm"
              class=""
              @click.prevent="viewDetail(data.item)"
              v-b-tooltip.hover.top="'Ver'"
              variant="flat-info"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>

            <b-button
              v-if="data.item.state === 'Observado' || data.item.state === 'Alerta'"
              size="sm"
              @click.prevent="confirmApprove(data.item)"
              v-b-tooltip.hover.top="'Aprobar'"
              variant="flat-success"
            >
              <feather-icon icon="CheckCircleIcon" />
            </b-button>
          </template>
            
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select';
import InternalMovement from '@/services/InternalMovement'
import StoresService from '@/services/StoresService'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      showLoading: false,
      records: [],
      fields: [
        { key: 'establishmentOrigin.name', label: 'Tienda Origen', sortable: false },
        { key: 'establishmentDestiny.name', label: 'Tienda Destino', sortable: false },
        { key: 'state', label: 'Estado', sortable: true },
        { key: 'documentCode', label: 'Nro Documento', sortable: false },
        { key: 'created_at', label: 'F. Creación', sortable: false },
        { key: 'actions', label: 'Acciones' }
      ],
      establishments: [],
      filterOrigin: null,
      filterDestiny: null,
      filterState: null,
      stateOptions: [
        { value: 'Observado', text: 'Observado' },
        { value: 'Aprobado', text: 'Aprobado' },
        { value: 'Alerta', text: 'Alerta' }
      ],
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  components:{
    vSelect
  },
  mounted() {
    this.fetchEstablishments();
    this.getData()
  },
  methods: {
    async getData() {
      this.records = [];
      this.totalElements = 0;
      this.showLoading = true;

      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`;
      const resp = await InternalMovement.getInternMovements(url, this.$store);

      if (resp.data.rows.length !== 0) {
        this.records = resp.data.rows.filter(record => 
          ["Observado", "Aprobado", "Alerta"].includes(record.state)
        );
        this.totalElements = this.records.length+1;
      }

      this.showLoading = false;
    },

    async fetchEstablishments() {
      const response = await StoresService.getStores('',this.$store);
      this.establishments = response.data.rows;
    },
    applyFilters() {
      this.arrayFilters = [];

      if (this.filterOrigin) {
        this.arrayFilters.push({
          keyContains: 'establishmentOrigin.id',
          key: 'equals',
          value: this.filterOrigin.id
        });
      }

      if (this.filterDestiny) {
        this.arrayFilters.push({
          keyContains: 'establishmentDestiny.id',
          key: 'equals',
          value: this.filterDestiny.id
        });
      }

      if (this.filterState) {
        this.arrayFilters.push({
          keyContains: 'state',
          key: 'equals',
          value: this.filterState
        });
      }

      this.getData();
    },
    clearFilters() {
      this.filterOrigin = null;
      this.filterDestiny = null;
      this.filterState = null;
      this.arrayFilters = [];
      this.getData(); 
    },
    confirmApprove(item) {
      this.$router.push('/inventario/entrada/observacion/aprobar/' + item.id)
    },

    cambioPagina(e) {
      this.currentPage = e
      this.getData()
    },
    changeSizePage() {
      this.getData()
    },
    sortChanged(data) {
      this.sort = data.sortBy
      this.order = data.sortDesc ? 'desc' : 'asc'
    },

    viewDetail(item) {
      this.$router.push('/inventario/entrada/observacion/' + item.id)
    }
  }
}
</script>
<style>
.state-alerta {
  background-color: #ff0000;
  padding: 5px 8px;
  border-radius: 4px;
  display: inline-block;
  color: #ffffff;
}
</style>
